module.exports = __webpack_public_path__ + "img/orderSuccess2x.png?846c9581d947d755d033d693eefd91bf";